<input [(ngModel)]="previousSearchesBurgerOpen" type="checkbox" id="previous-searches-burger"
       name="previous-searches-burger">
<label for="previous-searches-burger"
       [ngClass]="[previousSearchesBurgerOpen ? 'previousSearchBurger-open' : 'previousSearchBurger-closed']"
       class="previous-searches-burger">
    <div>
        <i class="bhi-search-menu"></i>
    </div>
</label>
<div class="previous-searches-burger-menu-container">
    <div class="previous-searches-burger-menu"></div>
    <h1>Previous <span class="red">Searches</span></h1>
    <ul class="links">
        <ng-container *ngFor="let group of groupedSearches | keyvalue">
            <mat-expansion-panel *ngIf="group.value.length > 0">
                <mat-expansion-panel-header>
                    <mat-panel-title class="search-section-title">
                        <ng-container [ngSwitch]="group.key">
                            <i class="section-icon bhi-check" *ngSwitchCase="'COMPLETED'"></i>
                            <span *ngSwitchCase="'RUNNING'" class="section-icon app-loading">
                              <svg class="spinner" viewBox="25 25 50 50">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10"/>
                              </svg>
                            </span>
                            <i class="section-icon bhi-clock" *ngSwitchCase="'QUEUED'"></i>
                            <i class="section-icon bhi-clock" *ngSwitchCase="'SCHEDULED'"></i>
                            <i class="section-icon bhi-close-o" *ngSwitchCase="'FAILED'"></i>
                        </ng-container>
                        {{ group.key[0] }}{{ group.key.substr(1).toLowerCase() }} ({{ group.value.length || '0' }})
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sub-links">
                    <li *ngFor="let item of group.value">
                        <a (click)="setReportSearch(item)">{{ item.searchName }}</a>
                        <i *ngIf="['SCHEDULED'].includes(group.key)" matTooltip="Delete {{item.searchName}}" class="bhi-delete-o" (click)="setDeleteSearch(item)"></i>
                    </li>
                </ul>
            </mat-expansion-panel>
        </ng-container>
    </ul>
</div>
